// extracted by mini-css-extract-plugin
module.exports =  {"folder":"_0bc5e8de02--folder--dHNi9","text":"_0bc5e8de02--text--nlEqt"};